import { Area } from '../types/Area';
import { Size } from '../types/Size';

export const sliceCropToSize = (cropBox: Area, imageContainerSize: Size) => {
    const containerAspectRatio = imageContainerSize.width / imageContainerSize.height;
    return sliceCropToAspect(cropBox, containerAspectRatio);
};

export const sliceCropToAspect = (cropBox: Area, containerAspectRatio: number) => {

    const cropAspectRatio = cropBox.width / cropBox.height;

    if (cropAspectRatio < containerAspectRatio) {
        const height = cropBox.height / containerAspectRatio * cropAspectRatio;
        return {
            x: cropBox.x,
            y: cropBox.y + 0.5 * (cropBox.height - height),
            height: height,
            width: cropBox.width
        };
    } else {
        const width = cropBox.width * containerAspectRatio / cropAspectRatio;
        return {
            x: cropBox.x + 0.5 * (cropBox.width - width),
            y: cropBox.y,
            height: cropBox.height,
            width: width
        };
    }
};